import { createFileRoute } from "@tanstack/react-router";
import { CountryChannelLanding } from "@/components/country/shared/CountryChannelLanding";

export const Route = createFileRoute("/mexico/tudn")({
  head: () => ({
    meta: [
      { title: "VerseSport México + TUDN — Segunda pantalla del Mundial" },
      { name: "description", content: "Acompaña la transmisión de TUDN con predicciones en vivo, Nation Wars y Audio Sync en VerseSport México." },
      { property: "og:title", content: "VerseSport México + TUDN" },
      { property: "og:description", content: "Predicciones, ranking del Tri y comunidad mientras ves TUDN." },
      { property: "og:url", content: "https://versesport.com/mexico/tudn" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/mexico/tudn" }],
  }),
  component: () => (
    <CountryChannelLanding country="MX" channelId="tudn" intro="Vive la transmisión de TUDN con predicciones en tiempo real, ranking del Tri y la comunidad mexicana." />
  ),
});